import axios from 'axios';
import { message } from 'antd';  // 添加这行
import AuthService from './auth';

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://dev-sso-backend.markableai.cn',
  timeout: 15000,
});

// 请求拦截器 - 自动添加Token到header
instance.interceptors.request.use(
  (config) => {
    // 从存储中获取Token
    const token = AuthService.getToken();
    
    // 如果有Token，添加到请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['X-Access-Token'] = token;
    }
    
    // 添加其他公共header
    config.headers['Content-Type'] = 'application/json';
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理Token过期等
instance.interceptors.response.use(
  (response) => {
    // 检查响应中是否有新的Token
    const newToken = response.headers['x-new-token'] || response.data?.newToken;
    if (newToken) {
      AuthService.setToken(newToken);
    }
    
    return response.data;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Token过期，清除存储后再重定向
          AuthService.clearToken();
          window.location.href = '/qrLogin';
          break;
        case 403:
          message.error('权限不足');  // 现在可以使用message了
          break;
        default:
          console.error('请求错误:', error);
      }
    } else {
      message.error('网络错误，请检查连接');
    }
    return Promise.reject(error);
  }
);

export default instance;